<script lang="ts">
  import LinkContent from "../../utils/LinkContent.svelte";
  import { handleURL, socialIcon } from "./utils";
  import { getRenderContext } from "../../../newsletterStores";

  import type { SocialType } from "./utils";

  const ctx = getRenderContext();

  export let handle: string | undefined = "";
  export let type: SocialType;
  export let color: string = "#fff";
</script>

{#if handle}
  <LinkContent cta={{ id: `footer.${type}`, url: handleURL(handle, type) }} linkText="{type} button" type="signature">
    <img src={ctx.svg(socialIcon(type, color), { shared: true })} alt="Signature {type}" width="15" height="14" />
  </LinkContent>
{/if}
